import DocumentUploadRequirements from "../components/Management/DocumentUploadRequirements";
import Header from "../components/shared/TailwindComponents/Header";

const DocumentUploadPage = () => {
  return (
    <div className="flex flex-col h-full">
      <Header subscriptionActive={true} />
      <div className="flex-1 min-h-0 overflow-auto relative px-4">
        <DocumentUploadRequirements userRole="LawFirmAdmin" />
      </div>
    </div>
  );
};

export default DocumentUploadPage;
